<script setup lang="ts">
import type PodcastEpisode from "~~/types/PodcastEpisode";
import { useHelper } from "~/composables/helper";

const { formatDate } = useHelper();

const props = defineProps({
    episode: {
        type: Object as PropType<PodcastEpisode>,
        required: true,
    },
});

const src = computed(() => {
    // Strip 'yt:video:' prefix if it exists
    const videoId = props.episode.id.replace("yt:video:", "");
    return `https://www.youtube.com/embed/${videoId}?si=${videoId}`;
});
</script>

<template>
    <div class="bg-abc-gray py-10">
        <div class="relative container lg:flex">
            <div class="flex flex-none items-center justify-center lg:h-96 lg:w-1/2">
                <!-- Tried to use the YouTubeEmbed component but it doesn't seem to work -->
                <iframe
                    loading="lazy"
                    :src="src"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    class="aspect-video w-full"
                ></iframe>
            </div>
            <div class="flex max-h-96 flex-1 flex-col pl-4">
                <h1 class="mb-4 flex-none text-4xl font-bold">{{ episode.title }}</h1>
                <div class="mb-2 flex-none text-sm text-gray-400 italic">{{ formatDate(episode.published) }}</div>
                <p class="flex-1 overflow-y-auto">
                    {{ episode.description }}
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
